/**
 * Exposes the binding key for every EmpathyX service
 */
export const DEPENDENCIES = {
  Adapter: Symbol.for('SearchAdapter'),
  AppBuilder: Symbol.for('AppBuilder'),
  StateCacheService: Symbol.for('StateCacheService'),
  ClientEventsDispatcher: Symbol.for('ClientEventsDispatcher'),
  ConfigBuilder: Symbol.for('ConfigBuilder'),
  EmpathyXAPI: Symbol.for('EmpathyXAPI'),
  FacetsReconstructor: Symbol.for('FacetsReconstructor'),
  HasUserNavigatedBackFromPDP: Symbol.for('HasUserNavigatedBackFromPDP'),
  PositionService: Symbol.for('PositionService'),
  ProductPageService: Symbol.for('ProductPageService'),
  ScreenWidthDetector: Symbol.for('ScreenWidthDetector'),
  ServiceRegistry: Symbol.for('ServiceRegistry'),
  /**
   * StorageService needs to be retrieved with a name. Either with @named(XXX) decorator, or with `container.getNamed` function
   * STORAGE const exposes all of the possible names
   */
  StorageService: Symbol.for('StorageService'),
  Store: Symbol.for('Store'),
  UserService: Symbol.for('UserService')
} as const;

/**
 * Exposes the name for every EmpathyX storage service
 */
export const STORAGE = {
  Local: 'local',
  Session: 'session'
} as const;
